module.exports = __webpack_public_path__ + "img/216.30469905.png";